import type { LangCode } from "../types";

export const BLOG_TRANSLATIONS: Record<
  string,
  Partial<Record<LangCode, { title: string; excerpt: string; body?: string; category?: string }>>
> = {
  // Turkish first, and for now Turkish only: this is a Turkish fair, in the
  // city VARS works from, and the audience most likely to act on the post
  // reads Turkish. The other seven locales fall back to the English title and
  // excerpt until they are written.
  "sv12-protocol-implementation-at-kilic-hatchery-with-japanese-experts": {
    fa: {
      title: "مطالعه موردی: اجرای پروتکل روتیفر SV12 در Kılıç، با حضور کارشناسان کلرلای ژاپن",
      excerpt:
        "در فوریه 2019 جعبه‌های ارسالی از چیکوگو به مرکز تکثیر Kılıç رسید — و همراه آن‌ها، همان کسانی که این پروتکل را ساخته بودند. اجرای میدانی SV12 در کنار مهندسان ژاپنی Chlorella Industry، در قاب تصویر.",
      category: "پروژه‌ها و آزمون‌های میدانی",
    },
    tr: {
      title: "Vaka Çalışması: Kılıç'ta SV12 Rotifer Protokolü",
      excerpt:
        "Şubat 2019'da Chikugo'dan gelen kutular Kılıç kuluçkahanesine ulaştı — protokolü geliştiren insanlar da onlarla birlikte geldi. SV12'nin Chlorella Industry'nin Japon mühendisleriyle sahada uygulanması, fotoğraflarla.",
      category: "Saha Projeleri ve Denemeler",
    },
    de: {
      title:
        "Fallstudie: Einführung des SV12-Rädertierchen-Protokolls bei Kılıç mit japanischen Chlorella-Experten vor Ort",
      excerpt:
        "Im Februar 2019 trafen die Kisten aus Chikugo in der Kılıç-Brutanlage ein — und mit ihnen die Entwickler des Protokolls. Die Implementierung von SV12 mit den japanischen Ingenieuren von Chlorella Industry in Bildern.",
      category: "Feldprojekte & Versuche",
    },
    es: {
      title:
        "Estudio de caso: Implementación del protocolo de rotíferos SV12 en Kılıç con expertos japoneses en Chlorella in situ",
      excerpt:
        "En febrero de 2019 llegaron las cajas desde Chikugo al criadero de Kılıç — y también los creadores del protocolo. Cómo fue implementar SV12 junto a los ingenieros japoneses de Chlorella Industry, en fotos.",
      category: "Proyectos y Ensayos de Campo",
    },
    fr: {
      title: "Étude de cas : le protocole rotifères SV12 chez Kılıç",
      excerpt:
        "En février 2019, les caisses venues de Chikugo sont arrivées à l'écloserie Kılıç — accompagnées de ceux qui avaient conçu le protocole. À quoi a réellement ressemblé la mise en œuvre du SV12 avec les ingénieurs japonais de Chlorella Industry, en photos.",
      category: "Projets",
    },
    ru: {
      title:
        "Кейс: Внедрение протокола коловраток SV12 на инкубатории Kılıç с японскими экспертами Chlorella на месте",
      excerpt:
        "В феврале 2019 года коробки из Чикуго прибыли на инкубаторий Kılıç — вместе с разработчиками протокола. Как проходило внедрение SV12 с японскими инженерами Chlorella Industry в фотографиях.",
      category: "Полевые проекты и испытания",
    },
    ar: {
      title:
        "دراسة حالة: تطبيق بروتوكول الروتيفير SV12 في مفرخ Kılıç بمشاركة خبراء الكلوريلا اليابانيين ميدانياً",
      excerpt:
        "في فبراير 2019 وصلت الصناديق من تشيكوغو إلى مفرخ Kılıç — ووصل معها مبتكرو البروتوكول. توثيق مصور لتطبيق SV12 جنباً إلى جنب مع مهندسي Chlorella Industry اليابانيين.",
      category: "مشاريع وتجارب ميدانية",
    },
    ja: {
      title:
        "導入事例：日本のクロレラ専門家が現地指導 — Kılıç社孵化場におけるSV12ワムシ培養プロトコルの導入",
      excerpt:
        "2019年2月、筑後から届いたSV12とともにプロトコルの開発者たちもKılıç孵化場に到着しました。クロレラ工業の日本人エンジニアによるSV12導入の現場を写真で振り返ります。",
      category: "現場プロジェクトと実証実験",
    },
    ko: {
      title:
        "사례 연구: 일본 클로렐라 전문가의 현장 지원을 통한 Kılıç 부화장 SV12 로티퍼 프로토콜 도입",
      excerpt:
        "2019년 2월 후쿠오카 치쿠고에서 발송된 배송 상자가 Kılıç 부화장에 도착했으며 프로토콜 개발자들도 함께 현장을 찾았습니다. 클로렐라 공업 일본 엔지니어들과 함께한 SV12 도입 과정을 사진으로 확인하세요.",
      category: "현장 프로젝트 및 실증 시험",
    },
    zh: {
      title: "案例研究：日本小球藻专家现场指导，Kılıç育苗场成功引入SV12轮虫培养规程",
      excerpt:
        "2019年2月，来自筑后的货箱运抵Kılıç育苗场，规程研发团队也随之抵达。通过现场实拍，回顾与日本Chlorella Industry工程师共同推进SV12落地的全过程。",
      category: "实地项目与试验",
    },
  },
  "super-fresh-chlorella-sv12-from-japan-to-your-rotifer-tanks": {
    fa: {
      title: "Super Fresh Chlorella SV12: از استخر کشت ژاپنی تا تانک‌های روتیفر شما",
      excerpt:
        "درون یک جعبه SV12 واقعاً چه چیزی هست، چگونه در کارخانه چیکوگو در فوکوئوکا پرورش می‌یابد، و برنامه تغذیه روزبه‌روزی که یک کشت روتیفر را از 200 به 1,200 عدد در میلی‌لیتر می‌رساند.",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Süper Taze Chlorella SV12: Japonya'dan Rotifer Tankına",
      excerpt:
        "Bir SV12 kutusunun içinde gerçekte ne var, Fukuoka'daki Chikugo tesisinde nasıl üretiliyor ve bir rotifer kültürünü mililitrede 200'den 1.200 bireye taşıyan gün gün besleme planı.",
      category: "Yem İnovasyonu ve Mikroalg",
    },
    de: {
      title: "Super Fresh Chlorella SV12: Vom japanischen Kulturbecken in Ihre Rädertierchen-Tanks",
      excerpt:
        "Was tatsächlich in einer Kiste SV12 steckt, wie es im Werk Chikugo in Fukuoka kultiviert wird und der tagesgenaue Fütterungsplan von 200 auf 1.200 Individuen pro Milliliter.",
      category: "Futtermittelinnovation & Mikroalgen",
    },
    es: {
      title:
        "Super Fresh Chlorella SV12: De una balsa de cultivo japonesa a sus tanques de rotíferos",
      excerpt:
        "Qué contiene realmente una caja de SV12, cómo se cultiva en la planta de Chikugo en Fukuoka y el plan de alimentación diario que eleva un cultivo de 200 a 1.200 individuos por mililitro.",
      category: "Innovación en Alimentos y Microalgas",
    },
    fr: {
      title: "Super Fresh Chlorella SV12 : du Japon à vos bassins",
      excerpt:
        "Ce que contient réellement une caisse de SV12, comment elle est cultivée à l'usine de Chikugo à Fukuoka, et le plan de distribution jour par jour qui fait passer une culture de rotifères de 200 à 1 200 individus par millilitre.",
      category: "Innovation alimentaire et microalgues",
    },
    ru: {
      title: "Super Fresh Chlorella SV12: Из японского бассейна в ваши танки с коловратками",
      excerpt:
        "Что на самом деле находится в коробке SV12, как она выращивается на заводе в Чикуго (Фукуока) и пошаговый план кормления, увеличивающий плотность с 200 до 1 200 особей на миллилитр.",
      category: "Инновации в кормах и микроводоросли",
    },
    ar: {
      title: "Super Fresh Chlorella SV12: من أحواض الاستزراع في اليابان إلى خزانات الروتيفير لديكم",
      excerpt:
        "ما تحتويه صناديق SV12 فعلياً، وكيفية زراعتها في مصنع تشيكوغو بفوكوكا، وجدول التغذية اليومي الذي يرفع كثافة الروتيفير من 200 إلى 1,200 فرد لكل مليلتر.",
      category: "الابتكار في الأعلاف والكائنات الدقيقة",
    },
    ja: {
      title: "Super Fresh Chlorella SV12：日本の培養プールから貴社のワムシ水槽へ",
      excerpt:
        "SV12の製品内容、福岡県筑後工場での生産体制、そしてワムシ密度を毎ミリリットルあたり200個体から1,200個体へと引き上げる日々の給餌管理プロトコル。",
      category: "飼料イノベーションと微細藻類",
    },
    ko: {
      title: "Super Fresh Chlorella SV12: 일본의 배양 수조에서 고객사의 로티퍼 수조까지",
      excerpt:
        "SV12 상자 내부의 실제 구성, 후쿠오카 치쿠고 공장에서의 생산 방식, 로티퍼 밀도를 밀리리터당 200마리에서 1,200마리까지 증식시키는 일자별 급이 계획.",
      category: "사료 혁신 및 미세조류",
    },
    zh: {
      title: "Super Fresh Chlorella SV12：从日本培养池到您的轮虫培养槽",
      excerpt:
        "详解SV12的实际品质构成、日本福冈筑后工厂的培养流程，以及将轮虫培养密度从每毫升200个提升至1,200个的逐日投喂方案。",
      category: "饲料创新与微藻",
    },
  },
  "vars-at-future-fish-eurasia-2026-izmir-stand-c237": {
    fa: {
      title: "در Future Fish Eurasia 2026 غرفه داریم — سالن C، غرفه C-237",
      excerpt:
        "24 تا 26 سپتامبر، Fuar İzmir. سه روز در شهر خودمان، و دعوتی باز: به‌جای گرفتن بروشور، یک مشخصات فنی برای ما بیاورید.",
      category: "نقاط عطف شرکت و صنعت",
    },
    tr: {
      title: "VARS Future Fish Eurasia 2026: Hol C, Stant C-237",
      excerpt:
        "24–26 Eylül, Fuar İzmir. Kendi şehrimizde üç gün ve açık bir davet: broşür almaya değil, bize bir şartname getirmeye gelin.",
      category: "Şirket ve Sektör Kilometre Taşları",
    },
    de: {
      title: "Wir stellen auf der Future Fish Eurasia 2026 aus — Halle C, Stand C-237",
      excerpt:
        "24.–26. September, Fuar İzmir. Drei Tage in unserer Heimatstadt und eine Einladung zum fachlichen Austausch über konkrete Spezifikationen.",
      category: "Unternehmens- & Branchenmeilensteine",
    },
    es: {
      title: "Exponemos en Future Fish Eurasia 2026 — Pabellón C, estand C-237",
      excerpt:
        "24–26 de septiembre, Fuar İzmir. Tres días en nuestra propia ciudad y una invitación abierta a conversar sobre especificaciones técnicas reales.",
      category: "Hitos de la Empresa y la Industria",
    },
    fr: {
      title: "VARS à Future Fish Eurasia 2026 : hall C, stand C-237",
      excerpt:
        "Du 24 au 26 septembre, Fuar İzmir. Trois jours dans notre propre ville, et une invitation ouverte : apportez-nous une spécification plutôt que de repartir avec une brochure.",
      category: "Actualités de l'entreprise",
    },
    ru: {
      title: "Мы участвуем в выставке Future Fish Eurasia 2026 — Зал C, стенд C-237",
      excerpt:
        "24–26 сентября, Fuar İzmir. Три дня в нашем родном городе и открытое приглашение обсудить технические спецификации вместо обычных буклетов.",
      category: "События компании и отрасли",
    },
    ar: {
      title: "نشارك في معرض Future Fish Eurasia 2026 — القاعة C، الجناح C-237",
      excerpt:
        "24–26 سبتمبر، في معارض إزمير (Fuar İzmir). ثلاثة أيام في مدينتنا، ودعوة مفتوحة لمناقشة المواصفات الفنية العملية بدلاً من مجرد توزيع الكتيبات.",
      category: "أخبار الشركة والقطاع",
    },
    ja: {
      title: "Future Fish Eurasia 2026 出展のご案内 — ホールC、スタンドC-237",
      excerpt:
        "2026年9月24日〜26日、Fuar İzmir。私たちが拠点を置く街で、カタログ配布にとどまらない具体的な技術仕様のご相談をお待ちしております。",
      category: "企業および業界のマイルストーン",
    },
    ko: {
      title: "Future Fish Eurasia 2026 박람회 참가 안내 — C홀 C-237 부스",
      excerpt:
        "2026년 9월 24일~26일, 푸아르 이즈미르(Fuar İzmir). 본사가 위치한 도시에서 단순한 브로슈어 전달을 넘어 구체적인 사양 협의를 위한 자리를 마련합니다.",
      category: "기업 및 업계 주요 소식",
    },
    zh: {
      title: "我们参展Future Fish Eurasia 2026 — C馆C-237展位",
      excerpt:
        "2026年9月24日至26日，伊兹密尔展会中心。在我们大本营展开为期三天的交流，诚邀各界同仁携具体技术指标前来深入洽谈。",
      category: "企业与行业里程碑",
    },
  },
  "beyond-the-brand-the-biological-reality-of-artemia-performance-in-turkiye-19": {
    fa: {
      title: "فراتر از برند: واقعیت زیستی عملکرد آرتمیا در ترکیه",
      excerpt: "کارنامه‌ای اثبات‌شده: آرتمیای Revive در ترکیه",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Türkiye'de Artemia Performansının Biyolojik Gerçeği",
      excerpt: "Kanıtlanmış Bir Miras: Türkiye'de Revive Artemia",
      category: "Yem İnovasyonu ve Mikroalg",
    },
    es: {
      title: "Más allá de la marca: la realidad biológica del rendimiento de la artemia en Turquía",
      excerpt: "Un legado probado: Revive Artemia en Turquía",
      category: "Innovación en Alimentos y Microalgas",
    },
    fr: {
      title: "La réalité biologique des performances de l'artémia en Türkiye",
      excerpt: "Un héritage éprouvé : l'artémia Revive en Türkiye",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title: "Jenseits der Marke: Die biologische Realität der Artemia-Leistung in der Türkei",
      excerpt: "Ein bewährtes Vermächtnis: Revive Artemia in der Türkei",
      category: "Futtermittelinnovation & Mikroalgen",
    },
    ru: {
      title: "Вне бренда: Биологическая реальность эффективности артемии в Турции",
      excerpt: "Проверенное наследие: Revive Artemia в Турции",
      category: "Инновации в кормах и микроводоросли",
    },
    ja: {
      title: "ブランドを超えて：トルコにおけるアルテミア性能の生物学的現実",
      excerpt: "証明された実績：トルコにおけるReviveアルテミア",
      category: "飼料革新と微細藻類",
    },
    ko: {
      title: "브랜드를 넘어서: 터키 내 알테미아 성능의 생물학적 현실",
      excerpt: "검증된 유산: 터키 내 Revive 알테미아",
      category: "사료 혁신 및 미세조류",
    },
    zh: {
      title: "超越品牌：土耳其丰年虫性能的的生物学现实",
      excerpt: "经受检验的传承：土耳其的 Revive 丰年虫",
      category: "饲料创新与微藻",
    },
    ar: {
      title: "ما وراء العلامة التجارية: الواقع البيولوجي لأداء الأرتيميا في تركيا",
      excerpt: "إرث مثبت: أرتيميا ريفايف في تركيا",
      category: "ابتكار الأعلاف والطحالب الدقيقة",
    },
  },
  "overcoming-the-top-10-challenges-in-salmon-egg-sourcing-and-management-16": {
    fa: {
      title: "غلبه بر 10 چالش اصلی در تأمین و مدیریت تخم ماهی آزاد",
      excerpt:
        "حتی برای مراکز تکثیر رده نخست، تأمین و مدیریت تخم ماهی آزاد کاری پرمخاطره است. در صنعتی که متغیرهای میکروسکوپی نتایج میلیون‌دلاری را رقم می‌زنند، تأمین مطمئن...",
      category: "مبانی و اصول آبزی‌پروری",
    },
    tr: {
      title: "Somon Yumurtası Tedariğinde 10 Temel Zorluk ve Çözüm",
      excerpt: "Endüstriyel Kuluçkahaneler İçin Kılavuz",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title: "Superar los 10 desafíos principales en el abastecimiento y manejo de ovas de salmón",
      excerpt: "Guía para criaderos industriales de salmón",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "Les 10 principaux défis de l'approvisionnement en œufs de saumon",
      excerpt:
        "Même pour les écloseries de premier rang, s'approvisionner en [œufs de saumon](/products/hatchery-solutions/atlantic-salmon-egg) et les gérer reste une opération à fort enjeu. Dans un secteur où des variables microscopiques déterminent des résultats à plusieurs millions, sécuris...",
      category: "Aquaculture : les fondamentaux",
    },
    de: {
      title:
        "Bewältigung der 10 größten Herausforderungen bei der Beschaffung und dem Management von Salmouneiern",
      excerpt: "Leitfaden für industrielle Brutanstalten",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Преодоление 10 основных трудностей при закупке и управлении икрой лосося",
      excerpt: "Руководство для промышленных инкубаторов",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "サーモン卵の調達と管理におけるトップ10の課題の克服",
      excerpt: "産業用孵化場向けガイド",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "연어 발안란 조달 및 관리의 10대 과제 극복",
      excerpt: "산업용 부화장을 위한 가이드",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "克服鲑鱼卵采购与管理中的前十大挑战",
      excerpt: "工业化孵化场指南",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "تجاوز أهم 10 تحديات في مصادر وإدارة بيض السلمون",
      excerpt: "دليل للمفرخات الصناعية",
      category: "هندسة المفرخات والأعلاف",
    },
  },
  "fresh-chlorella-and-artemia-a-proven-combination-to-boost-rotifer-production-15": {
    fa: {
      title: "کلرلای تازه SV-12: راه اثبات‌شده افزایش تولید روتیفر",
      excerpt:
        "هر مدیر مرکز تکثیر می‌داند که روتیفر ستون فقرات پرورش لارو است. تراکم، ارزش تغذیه‌ای و پایداری آن می‌تواند یک دوره کامل تولید را دگرگون کند. با این حال...",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Taze Chlorella SV-12 ile Rotifer Üretimi Artışı",
      excerpt: "Rotifer ve Artemia Üretiminde Taze Chlorella Kullanımı",
      category: "Yem İnovasyonu ve Mikroalg",
    },
    es: {
      title: "Chlorella SV-12 fresca: la forma probada de aumentar la producción de rotíferos",
      excerpt: "Uso de Chlorella fresca en la producción de rotíferos y artemia",
      category: "Innovación en Alimentos y Microalgas",
    },
    fr: {
      title: "Chlorella fraîche SV-12 : stimuler la production de rotifères",
      excerpt:
        "Tout responsable d'écloserie sait que les rotifères sont l'ossature de l'élevage larvaire. Leur densité, leur valeur nutritionnelle et leur stabilité peuvent peser lourdement sur un cycle d'écloserie. Pourtant, at...",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title:
        "Frische Chlorella SV-12: Der bewährte Weg zur Steigerung der Rädertierchen-Produktion",
      excerpt: "Einsatz von frischer Chlorella in der Rädertierchen- und Artemiazucht",
      category: "Futtermittelinnovation & Mikroalgen",
    },
    ru: {
      title: "Свежая хлорелла SV-12: проверенный способ ускорить производство коловраток",
      excerpt: "Использование свежей хлореллы в производстве коловраток и артемии",
      category: "Инновации в кормах и микроводоросли",
    },
    ja: {
      title: "新鮮なクロレラ SV-12：ワムシ生産を活性化する実証済みの方法",
      excerpt: "ワムシおよびアルテミア生産における新鮮なクロレラの活用",
      category: "飼料革新と微細藻類",
    },
    ko: {
      title: "신선한 클로렐라 SV-12: 로티퍼 생산량을 늘리는 검증된 방법",
      excerpt: "로티퍼 및 알테미아 생산에서 신선한 클로렐라의 활용",
      category: "사료 혁신 및 미세조류",
    },
    zh: {
      title: "鲜活小球藻 SV-12：提升轮虫产量的经验证途径",
      excerpt: "鲜活小球藻在轮虫与丰年虫培育中的应用",
      category: "饲料创新与微藻",
    },
    ar: {
      title: "كلوريلا SV-12 الطازجة: الطريقة المثبتة لزيادة إنتاج الروتيفير",
      excerpt: "استخدام الكلوريلا الطازجة في إنتاج الروتيفير والأرتيميا",
      category: "ابتكار الأعلاف والطحالب الدقيقة",
    },
  },
  "vars-aquaculture-the-first-and-largest-supplier-of-salmon-eggs-in-south-korea-17": {
    fa: {
      title: "VARS Aquaculture: نخستین و بزرگ‌ترین تأمین‌کننده تخم ماهی آزاد در کره جنوبی",
      excerpt:
        "بخش آبزی‌پروری کره جنوبی در دهه گذشته به‌سرعت رشد کرده است، و تخم ماهی آزاد به یکی از حیاتی‌ترین نهاده‌ها برای مراکز تکثیری تبدیل شده که یکنواختی و کیفیت بالا را هدف گرفته‌اند...",
      category: "مبانی و اصول آبزی‌پروری",
    },
    tr: {
      title: "VARS: Güney Kore'de Lider Somon Yumurtası Tedarikçisi",
      excerpt: "Güney Kore Su Ürünleri Yetiştiriciliği Pazarına Girişimiz",
      category: "Şirket ve Sektör Kilometre Taşları",
    },
    es: {
      title: "VARS Aquaculture: El primer y mayor proveedor de ovas de salmón en Corea del Sur",
      excerpt: "Nuestra entrada en el mercado acuícola de Corea del Sur",
      category: "Hitos de la Compañía y del Sector",
    },
    fr: {
      title: "VARS : premier fournisseur d'œufs de saumon en Corée du Sud",
      excerpt:
        "Le secteur aquacole sud-coréen s'est développé rapidement au cours de la dernière décennie, et les [œufs de saumon](/products/hatchery-solutions/atlantic-salmon-egg) sont devenus l'un des intrants les plus déterminants pour les écloseries visant une qualité régulière et éle...",
      category: "Aquaculture : les fondamentaux",
    },
    de: {
      title: "VARS Aquaculture: Der erste und größte Lieferant von Salmouneiern in Südkorea",
      excerpt: "Unser Eintritt in den südkoreanischen Aquakulturmarkt",
      category: "Unternehmens- & Branchen-Meilensteine",
    },
    ru: {
      title: "VARS Aquaculture: Первый и крупнейший поставщик икры лосося в Южную Корею",
      excerpt: "Наш выход на рынок аквакультуры Южной Кореи",
      category: "Вехи компании и отрасли",
    },
    ja: {
      title: "VARS Aquaculture：韓国初の最大級サーモン卵サプライヤー",
      excerpt: "韓国水産養殖市場への進出",
      category: "会社および業界の節目",
    },
    ko: {
      title: "VARS Aquaculture: 대한민국 최초이자 최대 연어 발안란 공급업체",
      excerpt: "대한민국 수산 양식 시장으로의 진출",
      category: "회사 및 업계 이정표",
    },
    zh: {
      title: "VARS Aquaculture：韩国首家及最大的鲑鱼卵供应商",
      excerpt: "进入韩国水产养殖市场",
      category: "公司与行业里程碑",
    },
    ar: {
      title: "فارس للاستزراع المائي: المورد الأول والأكبر لبيض السلمون في كوريا الجنوبية",
      excerpt: "دخولنا إلى سوق الاستزراع المائي في كوريا الجنوبية",
      category: "إنجازات الشركة والصناعة",
    },
  },
  "fertilized-salmon-eggs-where-every-salmon-farming-journey-begins-13": {
    fa: {
      title: "تخم بارورشده ماهی آزاد: جایی که هر مسیر پرورش ماهی آزاد از آن آغاز می‌شود",
      excerpt:
        "وارد یک مرکز تکثیر ماهی آزاد در نروژ، اسکاتلند یا شیلی که شوید، قلب تپنده آبزی‌پروری را در کار می‌بینید. در ردیف‌های سینی انکوباسیون، میلیون‌ها تخم بارورشده ماهی آزاد آرام گرفته‌اند...",
      category: "مبانی و اصول آبزی‌پروری",
    },
    tr: {
      title: "Döllenmiş Somon Yumurtası: Yetiştiriciliğin Temeli",
      excerpt: "Gözlenmiş Somon Yumurtası Yönetimi ve Tedariği",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title: "Ovas fertilizadas de salmón: donde comienza cada viaje de la salmonicultura",
      excerpt: "Manejo y abastecimiento de ovas oculadas de salmón",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "Œufs de saumon fécondés : le point de départ de l'élevage",
      excerpt:
        "Entrez dans une écloserie de saumon en Norvège, en Écosse ou au Chili et vous verrez le cœur de l'aquaculture à l'œuvre. Dans des rangées de claies d'incubation, des millions d'[œufs de saumon](/products/hatchery-solutions/atlantic-salmon-egg) fécondés reposent s...",
      category: "Aquaculture : les fondamentaux",
    },
    de: {
      title: "Befruchtete Salmouneier: Wo jede Lachsaufzucht-Reise beginnt",
      excerpt: "Management und Beschaffung von Salmouneiern im Augenpunktstadium",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Оплодотворенная икра лосося: С чего начинается выращивание лосося",
      excerpt: "Управление и закупка икры лосося на стадии глазка",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "受精サーモン卵：すべてのサーモン養殖の旅が始まる場所",
      excerpt: "発眼卵の管理と調達",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "연어 수정란: 연어 양식의 모든 여정이 시작되는 곳",
      excerpt: "연어 발안란의 관리와 공급",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "受精鲑鱼卵：鲑鱼养殖旅程的起点",
      excerpt: "鲑鱼发眼卵的管理与采购",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "بيض السلمون الملقح: من هنا تبدأ رحلة استزراع السلمون",
      excerpt: "إدارة وتوريد بيض السلمون الملقح في الطور العيني",
      category: "هندسة المفرخات والأعلاف",
    },
  },
  "the-role-of-wheat-gluten-in-aquaculture-14": {
    fa: {
      title: "نقش گلوتن گندم در آبزی‌پروری",
      excerpt:
        "آبزی‌پروری امروز فراتر از پرورش ماهی است — سخن از تغذیه جهانی رو به رشد است، در تعادل میان پایداری، کارایی و سودآوری. دهه‌ها پودر ماهی گزینه اصلی بود...",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Su Ürünleri Yetiştiriciliğinde Buğday Gluteni'nin Rolü",
      excerpt: "Yem Bağlayıcı ve Protein Kaynağı Olarak Vital Buğday Gluteni",
      category: "Yem İnovasyonu ve Mikroalg",
    },
    es: {
      title: "El papel del gluten de trigo en la acuicultura",
      excerpt: "Gluten de trigo vital como aglutinante y fuente de proteína en alimentos",
      category: "Innovación en Alimentos y Microalgas",
    },
    fr: {
      title: "Le rôle du gluten de blé en aquaculture",
      excerpt:
        "L'aquaculture ne consiste plus seulement à élever du poisson : il s'agit de nourrir un monde en croissance tout en conciliant durabilité, efficacité et rentabilité. Pendant des décennies, la farine de poisson a été l...",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title: "Die Rolle von Weizengluten in der Aquakultur",
      excerpt: "Vital-Weizengluten als Bindemittel und Proteinquelle in Futtermitteln",
      category: "Futtermittelinnovation & Mikroalgen",
    },
    ru: {
      title: "Роль пшеничной клейковины в аквакультуре",
      excerpt: "Пшеничный глютен как связующее вещество и источник белка",
      category: "Инновации в кормах и микроводоросли",
    },
    ja: {
      title: "水産養殖における小麦グルテンの役割",
      excerpt: "飼料バインダーおよびタンパク質源としての活性小麦グルテン",
      category: "飼料革新と微細藻類",
    },
    ko: {
      title: "수산 양식에서 밀 글루텐의 역할",
      excerpt: "사료 바인더 및 단백질원으로서의 활성 밀 글루텐",
      category: "사료 혁신 및 미세조류",
    },
    zh: {
      title: "小麦面筋粉（谷朊粉）在水产养殖中的作用",
      excerpt: "谷朊粉作为饲料粘合剂与植物蛋白源的作用",
      category: "饲料创新与微藻",
    },
    ar: {
      title: "دور غلوتين القمح في الاستزراع المائي",
      excerpt: "غلوتين القمح الحيوي كرابط ومصدر للبروتين في الأعلاف",
      category: "ابتكار الأعلاف والطحالب الدقيقة",
    },
  },
  "dry-artemia-cyst-guide-boost-your-hatch-rate-larval-nutrition-12": {
    fa: {
      title: "راهنمای سیست خشک آرتمیا: افزایش درصد تفریخ و بهبود تغذیه لارو",
      excerpt:
        "راهنمای کاربردی سیست‌های خشک آرتمیا: زیست‌شناسی کریپتوبیوز، پارامترهای تفریخ ۲۴ ساعته، عیب‌یابی درصد تفریخ و غنی‌سازی HUFA.",
      category: "مهندسی مرکز تکثیر و خوراک",
    },
    tr: {
      title: "Kuru Artemia Kisti: Açılım Oranı ve Larva Besleme",
      excerpt:
        "Kuru Artemia kistleri için operasyonel rehber: Kriptobiyoz biyolojisi, 24 saatlik açılım parametreleri, %90 üzeri açılım sorun giderme ve HUFA zenginleştirme.",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title: "Guía de cistes secos de artemia: optimice su tasa de eclosión y nutrición larval",
      excerpt:
        "Guía operativa de quistes secos de artemia: biología de la criptobiosis, parámetros de eclosión en 24h, diagnóstico de fallos y enriquecimiento HUFA.",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "Guide des cystes d'artémia secs : éclosion et nutrition larvaire",
      excerpt:
        "Guide opérationnel des cystes d'artémia secs : biologie de la cryptobiose, paramètres d'éclosion sur 24 heures, diagnostic des taux d'éclosion supérieurs à 90 % et protocoles d'enrichissement en HUFA.",
      category: "Conception des aliments d'écloserie",
    },
    de: {
      title: "Leitfaden für trockene Artemia-Zysten: Steigern Sie Schlupfrate und Larvennahrung",
      excerpt:
        "Praxisleitfaden für trockene Artemia-Zysten: Kryptobiose-Biologie, 24-Stunden-Schlupfparameter, Fehlerbehebung bei geringem Schlupf und HUFA-Anreicherung.",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Руководство по сухим цистам артемии: повысьте процент вылупления и питание личинок",
      excerpt:
        "Практическое руководство по сухим цистам артемии: биология криптобиоза, параметры 24-часовой инкубации, устранение причин низкого выклева и обогащение HUFA.",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "乾燥アルテミアシストガイド：孵化率と仔魚栄養の最大化",
      excerpt:
        "乾燥アルテミア耐久卵の実践的活用指針：休眠現象の生物学、24時間孵化管理条件、孵化率90%以上達成のトラブルシューティングおよび高度不飽和脂肪酸強化法。",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "건조 알테미아 시스트 가이드: 부화율 및 자어 영양 향상",
      excerpt:
        "건조 알테미아 시스트 실무 기술 가이드: 휴면포란 생리학, 24시간 표준 부화 환경, 90% 이상 부화율 관리 및 필수지방산(HUFA) 영양 강화 프로토콜.",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "干燥丰年虫卵指南：提高孵化率与幼体营养",
      excerpt:
        "干燥丰年虫卵实用操作指南：隐生生物学机制、24小时标准孵化调控、90%以上出苗率故障排查与高不饱和脂肪酸（HUFA）强化策略。",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "دليل حويصلات الأرتيميا الجافة: ضاعف معدل الفقس وتغذية اليرقات",
      excerpt:
        "دليل عملي لحويصلات الأرتيميا الجافة: بيولوجيا السكون الجنيني، معايير الفقس خلال 24 ساعة، حل مشكلات انخفاض نسبة الفقس وبروتوكولات الإثراء بالأحماض الدهنية.",
      category: "هندسة المفرخات والأعلاف",
    },
  },
  "our-journey-in-aquaculture-from-vision-to-industry-leader-in-live-feed-solutions-11": {
    fa: {
      title: "مسیر ما در آبزی‌پروری: از یک چشم‌انداز تا پیشرو صنعت در راهکارهای غذای زنده",
      excerpt: "از یک چشم‌انداز زیست‌فناورانه تا نوآوری در صنعت",
      category: "نقاط عطف شرکت و صنعت",
    },
    tr: {
      title: "VARS Yolculuğu: Canlı Yem Çözümlerinde Liderlik",
      excerpt: "VARS Su Ürünleri'nin Kuruluşu ve Gelişimi",
      category: "Şirket ve Sektör Kilometre Taşları",
    },
    es: {
      title:
        "Nuestro viaje en la acuicultura: de la visión al liderazgo en soluciones de alimento vivo",
      excerpt: "Fundación y trayectoria de VARS Aquaculture",
      category: "Hitos de la Compañía y del Sector",
    },
    fr: {
      title: "Notre parcours : des solutions de proies vivantes de référence",
      excerpt: "D'une vision biotechnologique à l'innovation sectorielle",
      category: "Actualités de l'entreprise",
    },
    de: {
      title:
        "Unsere Reise in der Aquakultur: Von der Vision zum Branchenführer bei Lebendfutterlösungen",
      excerpt: "Gründung und Entwicklung von VARS Aquaculture",
      category: "Unternehmens- & Branchen-Meilensteine",
    },
    ru: {
      title: "Наш путь в аквакультуре: от концепции к лидерству в решениях для живых кормов",
      excerpt: "Основание и развитие VARS Aquaculture",
      category: "Вехи компании и отрасли",
    },
    ja: {
      title: "水産養殖における私たちの歩み：ビジョンから生き餌ソリューションの業界リーダーへ",
      excerpt: "VARS Aquacultureの設立と沿革",
      category: "会社および業界の節目",
    },
    ko: {
      title: "수산 양식에서의 우리의 여정: 비전에서 생먹이 솔루션의 업계 리더로",
      excerpt: "VARS Aquaculture의 설립과 발전 과정",
      category: "회사 및 업계 이정표",
    },
    zh: {
      title: "我们的水产养殖之旅：从愿景到活体饲料解决方案的行业领导者",
      excerpt: "VARS Aquaculture 的创立与发展历程",
      category: "公司与行业里程碑",
    },
    ar: {
      title: "رحلتنا في الاستزراع المائي: من الرؤية إلى ريادة قطاع حلول الأعلاف الحية",
      excerpt: "تأسيس وتطور شركة فارس للاستزراع المائي",
      category: "إنجازات الشركة والصناعة",
    },
  },
  "rotifers-artemia-cornerstones-of-sustainable-aquaculture-nutrition-9": {
    fa: {
      title: "روتیفر و آرتمیا: سنگ‌بنای تغذیه پایدار در آبزی‌پروری",
      excerpt:
        "مدیریت کینتیک تکثیر روتیفر، بیوانرژتیک ناپلیوس آرتمیا (اینستار ۱ و ۲) و غنی‌سازی با DHA/EPA/ARA در تغذیه لاروی ماهیان دریایی.",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Rotifer ve Artemia: Akuakültür Beslemesinin Temeli",
      excerpt:
        "Deniz balığı larva yetiştiriciliğinde rotifer kültür kinetiği, Instar-I ve Instar-II Artemia biyoenerjetiği ve DHA/EPA/ARA zenginleştirme yönetimi.",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title: "Rotíferos y artemia: pilares de la nutrición acuícola sostenible",
      excerpt:
        "Cinética de cultivo de rotíferos, bioenergética de nauplios de Artemia Instar-I y II, y enriquecimiento lipídico (DHA/EPA/ARA) en larvicultura marina.",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "Rotifères et artémia : les piliers de la ration aquacole",
      excerpt:
        "Piloter la cinétique des cultures de rotifères, la bioénergétique de l'artémia aux stades I et II, et la bio-encapsulation du DHA, de l'EPA et de l'ARA en larviculture marine.",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title: "Rädertierchen & Artemia: Grundpfeiler einer nachhaltigen Aquakultur-Ernährung",
      excerpt:
        "Kulturkinetik von Rädertierchen, Bioenergetik von Instar-I- und Instar-II-Artemia sowie Fettabsicherung (DHA/EPA/ARA) in der marinen Larvenaufzucht.",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Коловратки и артемия: основа устойчивого питания в аквакультуре",
      excerpt:
        "Кинетика культивирования коловраток, биоэнергетика науплиусов артемии Instar-I и II, и протоколы обогащения DHA/EPA/ARA для личинок морских рыб.",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "ワムシとアルテミア：持続可能な水産養殖栄養の礎石",
      excerpt:
        "海産魚種苗生産におけるワムシ増殖キネティクス、アルテミア・インスターIおよびIIの生体エネルギー学、DHA/EPA/ARA栄養強化プロトコル。",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "로티퍼와 알테미아: 지속 가능한 수산 양식 영양의 초석",
      excerpt:
        "해산어 자치어 사육에서 로티퍼 배양 속도론, 알테미아 인스타-I 및 인스타-II 생체에너지학, 그리고 DHA/EPA/ARA 영양강화 관리 지침.",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "轮虫与丰年虫：可持续水产养殖营养的基石",
      excerpt:
        "海水鱼类苗种繁育中的轮虫增殖动力学、丰年虫无节幼体Instar-I与II期生物能量学，以及DHA/EPA/ARA营养强化管理。",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "الروتيفير والأرتيميا: ركائز التغذية المستدامة للأحياء المائية",
      excerpt:
        "إدارة حركية تكاثر الروتيفير، وديناميكية طاقة يرقات الأرتيميا (المرحلة الأولى والثانية)، والإثراء الغذائي بـ DHA/EPA/ARA ليرقات الأسماك البحرية.",
      category: "هندسة المفرخات والأعلاف",
    },
  },
  "live-feeds-in-hatcheries-aquariums-common-questions-and-expert-solutions-10": {
    fa: {
      title: "غذای زنده در مراکز تکثیر و آکواریوم‌ها: پرسش‌های رایج و پاسخ‌های کارشناسی",
      excerpt: "1. چرا روتیفر و آرتمیا در مراکز تکثیر اهمیت دارند",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Canlı Yem Rehberi: Kuluçkahane ve Akvaryum SSS",
      excerpt: "Canlı Yem Yetiştiriciliği ve Karşılaşılan Sorunlar",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title:
        "Alimentos vivos en criaderos y acuarios: preguntas frecuentes y soluciones de expertos",
      excerpt: "Manejo del alimento vivo y solución de problemas comunes",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "Proies vivantes en écloserie et en aquarium : FAQ d'experts",
      excerpt: "1. Pourquoi les rotifères et l'artémia comptent en écloserie",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title: "Lebendfutter in Brutanstalten & Aquarien: Häufige Fragen und Expertenlösungen",
      excerpt: "Lebendfutterkultur und Fehlerbehebung bei typischen Problemen",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Живые корма в инкубаторах и аквариумах: частые вопросы и решения экспертов",
      excerpt: "Выращивание живых кормов и устранение типичных проблем",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "孵化場とアクアリウムの生き餌：よくある質問と専門的な解決策",
      excerpt: "生き餌培養における一般的な課題とトラブルシューティング",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "부화장 및 아쿠아리움의 생먹이: 자주 묻는 질문과 전문가의 해결책",
      excerpt: "생먹이 배양 중 발생하는 대표적 문제점과 해결 방안",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "孵化场与水族箱中的活体饲料：常见问题与专家解决方案",
      excerpt: "活体饲料培育与常见问题排查",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "الأعلاف الحية في المفرخات والأحواض: أسئلة شائعة وحلول من الخبراء",
      excerpt: "استزراع الأعلاف الحية وحل المشكلات الشائعة",
      category: "هندسة Mفرخات والأعلاف",
    },
  },
  "unlock-the-full-power-of-potato-protein-meal-in-seabass-seabream-feeds-6": {
    fa: {
      title: "بهره‌گیری کامل از پودر پروتئین سیب‌زمینی در خوراک سی‌باس و شانک طلایی",
      excerpt: "مقدمه",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Çipura ve Levrek Yemlerinde Patates Proteini Unu",
      excerpt: "Levrek ve Çipura Yemlerinde Alternatif Bitkisel Protein Kaynağı",
      category: "Yem İnovasyonu ve Mikroalg",
    },
    es: {
      title: "Libere el poder de la proteína de papa en alimentos para lubina y dorada",
      excerpt: "Fuente alternativa de proteína vegetal para dietas de lubina y dorada",
      category: "Innovación en Alimentos y Microalgas",
    },
    fr: {
      title: "Protéine de pomme de terre dans les aliments bar et daurade",
      excerpt:
        "Le concentré de protéine de pomme de terre affiche une digestibilité in vitro de 88,8 % et peut remplacer jusqu'à 20 % de la farine de poisson dans les aliments pour bar et daurade royale. Les données d'essai et les limites.",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title:
        "Nutzen Sie das volle Potenzial von Kartoffelproteinmehl in Wolfsbarsch- und Goldbrassenfutter",
      excerpt: "Alternative pflanzliche Proteinquelle für Wolfsbarsch- und Goldbrassendiäten",
      category: "Futtermittelinnovation & Mikroalgen",
    },
    ru: {
      title: "Раскройте потенциал картофельного протеина в кормах для сибаса и дорады",
      excerpt: "Альтернативный источник растительного белка в рационах сибаса и дорады",
      category: "Инновации в кормах и микроводоросли",
    },
    ja: {
      title: "スズキ・タイ用飼料におけるポテトプロテインミールの有効活用",
      excerpt: "スズキとマダイの飼料設計における代替植物性タンパク質源",
      category: "飼料革新と微細藻類",
    },
    ko: {
      title: "농어 및 도미 사료에서 감자 단백질 분말의 효능 극대화",
      excerpt: "농어와 도미 배합 사료에서 대체 식물성 단백질원 활용",
      category: "사료 혁신 및 미세조류",
    },
    zh: {
      title: "释放土豆蛋白粉在海鲈与金头鲷饲料中的全部效能",
      excerpt: "海鲈与金头鲷日粮的替代植物蛋白源",
      category: "饲料创新与微藻",
    },
    ar: {
      title: "استفد من الإمكانات الكاملة لبروتين البطاطس في أعلاف القاروص والدنيس",
      excerpt: "مصدر بديل للبروتين النباتي في علائق القاروص والدنيس",
      category: "ابتكار الأعلاف والطحالب الدقيقة",
    },
  },
  "moist-pellets-for-fish-superior-palatability-efficiency-easy-production-7": {
    fa: {
      title: "پلت مرطوب برای ماهی: خوش‌خوراکی برتر، کارایی بالا و تولید آسان",
      excerpt:
        "شیمی فرمولاسیون پلت‌های مرطوب (رطوبت ۲۰ تا ۳۵٪): اتصال سرد با گلوتن گندم، حفظ جاذب‌های حساس به حرارت و روش تولید در محل.",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Balıklar İçin Yaş Pelet: Verimlilik ve Üretim",
      excerpt:
        "Nemli peletlerin formülasyon kimyası (%20-35 nem): buğday gluteni ile soğuk bağlama, ısıya duyarlı bileşenlerin korunması ve yerinde ekstrüzyon.",
      category: "Yem İnovasyonu ve Mikroalg",
    },
    es: {
      title: "Pellets húmedos para peces: palatabilidad superior, eficiencia y producción sencilla",
      excerpt:
        "Formulación de pellets húmedos (20-35% de humedad): aglutinación en frío con gluten de trigo vital y extrusión in situ de alta digestibilidad.",
      category: "Innovación en Alimentos y Microalgas",
    },
    fr: {
      title: "Granulés humides : appétence et production",
      excerpt:
        "Chimie de formulation des granulés humides (20 à 35 % d'humidité) : liaison à froid au gluten de blé vital, préservation des attractants thermosensibles et mode opératoire d'extrusion sur site.",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title:
        "Feuchtpellets für Fische: Überlegene Schmackhaftigkeit, Effizienz & einfache Herstellung",
      excerpt:
        "Rezepturchemie von Feuchtpellets (20-35 % Feuchte): Kaltbindung mit Weizengluten, Schutz hitzelabiler Lockstoffe und Vor-Ort-Extrusion.",
      category: "Futtermittelinnovation & Mikroalgen",
    },
    ru: {
      title:
        "Влажные гранулы для рыб: высокая вкусовая привлекательность, эффективность и простое производство",
      excerpt:
        "Рецептура влажных гранул (влажность 20-35%): холодное связывание пшеничным глютеном, сохранность аттрактантов и экструзия на месте.",
      category: "Инновации в кормах и микроводоросли",
    },
    ja: {
      title: "魚用モイストペレット：優れた嗜好性、効率性、そして簡単な製造",
      excerpt:
        "モイストペレット（水分20〜35%）の配合設計：活性小麦グルテンによるコールドバインディング、熱変性防止、および現場製造SOP。",
      category: "飼料革新と微細藻類",
    },
    ko: {
      title: "물고기용 습식 펠렛: 우수한 기호성, 효율성 및 간편한 제조 방법",
      excerpt:
        "습식 펠렛(수분 20~35%)의 배합 과학: 활성 소맥 글루텐을 이용한 비가열 결착, 열변성 영양소 보존 및 현장 압출 생산 지침.",
      category: "사료 혁신 및 미세조류",
    },
    zh: {
      title: "鱼用软颗粒饲料（湿性饲料）：优异的适口性、效率与简易生产",
      excerpt:
        "湿性软颗粒饲料（含水率20-35%）配方机制：谷朊粉冷法粘结、热敏诱食成分保留与现场挤压生产规范。",
      category: "饲料创新与微藻",
    },
    ar: {
      title: "الحبيبات الرطبة للأسماك: مستساغة للغاية، وفعالة وسهلة الإنتاج",
      excerpt:
        "كيمياء تركيب الحبيبات الرطبة (20-35% رطوبة): الربط البارد بغلوتين القمح، وحماية المحفزات الحساسة للحرارة، والتصنيع الميداني.",
      category: "ابتكار الأعلاف والطحالب الدقيقة",
    },
  },
  "chemical-vs-biochemical-elements-classification-and-essential-roles-in-life-8": {
    fa: {
      title: "عناصر شیمیایی در برابر عناصر زیست‌شیمیایی: طبقه‌بندی و نقش‌های حیاتی در زندگی",
      excerpt: "1. عناصر شیمیایی در برابر عناصر زیست‌شیمیایی",
      category: "نوآوری در خوراک و ریزجلبک",
    },
    tr: {
      title: "Akuakültürde Kimyasal ve Biyokimyasal Elementler",
      excerpt: "Su Ürünlerinde Minerallerin ve Biyokimyasal Elementlerin Fonksiyonları",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title: "Elementos químicos vs. bioquímicos: clasificación y funciones esenciales en la vida",
      excerpt: "Funciones de los minerales y elementos bioquímicos en organismos acuáticos",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "Éléments chimiques et biochimiques en aquaculture",
      excerpt: "1. Éléments chimiques et éléments biochimiques",
      category: "Innovation alimentaire et microalgues",
    },
    de: {
      title: "Chemische vs. biochemische Elemente: Klassifizierung und essentielle Rollen im Leben",
      excerpt: "Funktionen von Mineralien und biochemischen Elementen in Wasserorganismen",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Химические и биохимические элементы: классификация и ключевая роль в жизни",
      excerpt: "Функции минералов и биохимических элементов в водных организмах",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "化学元素対生化学元素：分類と生命における不可欠な役割",
      excerpt: "水生生物におけるミネラルと生化学元素の機能",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "화학적 원소 대 생화학적 원소: 분류 및 생명 유지에 필요한 주요 역할",
      excerpt: "수생 생물에서 미네랄 및 생화학적 원소의 기능",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "化学元素与生化元素：分类及其在生命体中的重要作用",
      excerpt: "矿物质与生化元素在水生生物体内的功能",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "العناصر الكيميائية مقابل البيوكيميائية: التصنيف والأدوار الأساسية في الحياة",
      excerpt: "وظائف المعادن والعناصر البيوكيميائية في الكائنات المائية",
      category: "هندسة المفرخات والأعلاف",
    },
  },
  "understanding-eyed-salmon-eggs-survival-biosecurity-international-hatchery-supply-20": {
    fa: {
      title:
        "شناخت تخم بارورشده ماهی آزاد در مرحله چشم‌زدگی: بقا، امنیت زیستی و تأمین بین‌المللی مراکز تکثیر",
      excerpt: "مقدمه",
      category: "مبانی و اصول آبزی‌پروری",
    },
    tr: {
      title: "Gözlü Somon Yumurtası: Biyogüvenlik ve Tedarik",
      excerpt: "Somon Yumurtası Kuluçkahane Yönetimi ve Nakliye Kılavuzu",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title:
        "Comprender las ovas oculadas de salmón: supervivencia, bioseguridad y suministro global",
      excerpt: "Manejo de ovas de salmón en criaderos y guía de transporte internacional",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "Œufs de saumon embryonnés : survie, biosécurité, sourcing",
      excerpt:
        "Pourquoi les œufs de saumon voyagent mieux au stade embryonné : développement de l'embryon, survie au transport, biosécurité et certification, et ce qu'il faut exiger d'un fournisseur.",
      category: "Aquaculture : les fondamentaux",
    },
    de: {
      title:
        "Salmouneier im Augenpunktstadium verstehen: Überleben, Biosicherheit & globale Lieferung",
      excerpt:
        "Management von Salmouneiern in Brutanstalten und internationaler Transportleitfaden",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Икра лосося на стадии глазка: выживаемость, биобезопасность и международные поставки",
      excerpt: "Управление икрой лосося в инкубаторах и руководство по транспортировке",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "サーモン発眼卵の理解：生存率、バイオセキュリティ、および国際供給体制",
      excerpt: "サーモン卵の孵化管理と国際輸送マニュアル",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "연어 발안란의 이해: 생존율, 바이오보안 및 글로벌 공급 관리",
      excerpt: "연어 양식장 발안란 관리 및 국제 운송가이드",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "了解鲑鱼发眼卵：成活率、生物安全与国际孵化场供应",
      excerpt: "鲑鱼发眼卵的孵化场管理与国际运输指南",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "فهم بيض السلمون في الطور العيني: البقاء، الأمن الحيوي والتوريد العالمي",
      excerpt: "إدارة بيض السلمون في المفرخات ودليل النقل الدولي",
      category: "هندسة المفرخات والأعلاف",
    },
  },
  "unlocking-the-power-of-dried-artemia-feed-in-modern-aquaculture-4": {
    fa: {
      title: "بهره‌گیری از توان آرتمیای خشک در آبزی‌پروری نوین",
      excerpt:
        "در دنیای پرشتاب آبزی‌پروری، نوآوری در خوراک یکی از حیاتی‌ترین مؤلفه‌های موفقیت مرکز تکثیر است. در میان مطمئن‌ترین و آزموده‌ترین گزینه‌ها برای پرورش لارو...",
      category: "مهندسی مرکز تکثیر و خوراک",
    },
    tr: {
      title: "Modern Akuakültürde Kuru Artemia Yeminin Gücü",
      excerpt: "Kuru Artemia Kistlerinin Larva Gelişimindeki Yeri ve Önemi",
      category: "Kuluçkahane ve Yem Mühendisliği",
    },
    es: {
      title: "Liberar el poder del alimento de artemia seca en la acuicultura moderna",
      excerpt: "El papel y valor de los quistes secos de artemia en el crecimiento de larvas",
      category: "Ingeniería de Criaderos y Alimentos",
    },
    fr: {
      title: "L'artémia séchée dans l'écloserie aquacole moderne",
      excerpt:
        "Dans un secteur aquacole en évolution rapide, l'innovation alimentaire est l'un des facteurs les plus déterminants de la réussite d'une écloserie. Parmi les solutions les plus fiables et les plus éprouvées pour l'élevage larvaire...",
      category: "Conception des aliments d'écloserie",
    },
    de: {
      title: "Nutzen Sie das Potenzial von Trocken-Artemia-Futter in der modernen Aquakultur",
      excerpt: "Die Bedeutung trockener Artemia-Zysten für das Wachstum von Fischlarven",
      category: "Brutanstalt & Futtermitteltechnik",
    },
    ru: {
      title: "Использование сухого корма из артемии в современной аквакультуре",
      excerpt: "Роль и ценность сухих цист артемии в росте личинок",
      category: "Проектирование инкубаторов и кормов",
    },
    ja: {
      title: "現代の水産養殖における乾燥アルテミア飼料の有効活用",
      excerpt: "仔魚の成長における乾燥アルテミアシストの役割と栄養価",
      category: "孵化場・飼料エンジニアリング",
    },
    ko: {
      title: "현대 수산 양식에서 건조 알테미아 사료의 장점 활용",
      excerpt: "자어 성장에서 건조 알테미아 시스트의 역할과 영양적 가치",
      category: "부화장 및 사료 엔지니어링",
    },
    zh: {
      title: "释放干丰年虫饲料在现代水产养殖中的功效",
      excerpt: "干燥丰年虫卵在鱼苗培育中的作用与价值",
      category: "孵化场与饲料工程",
    },
    ar: {
      title: "استغلال قوة علف الأرتيميا الجاف في الاستزراع المائي الحديث",
      excerpt: "دور وقيمة حويصلات الأرتيميا الجافة في نمو اليرقات",
      category: "هندسة المفرخات والأعلاف",
    },
  },
  "vars-strengthens-global-presence-at-bexco-fair-in-south-korea-3": {
    fa: {
      title: "VARS در BISFE 2024: حضور ما در نمایشگاه آبزیان و شیلات بوسان",
      excerpt:
        "مروری مستند بر حضور VARS Aquaculture در BISFE 2024 در بوسان، با معرفی سیست آرتمیا، تخم ماهی آزاد و کلرلای تازه.",
      category: "نقاط عطف شرکت و صنعت",
    },
    tr: {
      title: "VARS BISFE 2024'te: Busan Su Ürünleri Fuarı",
      excerpt:
        "VARS'ın BISFE 2024'te Artemia kistleri, somon yumurtaları ve taze Chlorella ile gerçekleştirdiği doğrulanmış fuar katılımı.",
      category: "Şirket ve Sektör Kilometre Taşları",
    },
    es: {
      title: "VARS en BISFE 2024: nuestra participación en la exposición pesquera de Busan",
      excerpt:
        "Un repaso verificado de la participación de VARS en BISFE 2024 con quistes de Artemia, huevos de salmón y Chlorella fresca.",
      category: "Hitos de la Compañía y del Sector",
    },
    fr: {
      title: "VARS au BISFE 2024 : salon des produits de la mer de Busan",
      excerpt:
        "Retour documenté sur la participation de VARS Aquaculture au BISFE 2024 à Busan, où l'entreprise a présenté ses cystes d'artémia, ses œufs de saumon et sa Chlorella fraîche.",
      category: "Actualités de l'entreprise",
    },
    de: {
      title: "VARS auf der BISFE 2024: unsere Teilnahme an der Fischereimesse in Busan",
      excerpt:
        "Ein verifizierter Rückblick auf die Teilnahme von VARS an der BISFE 2024 mit Artemia-Zysten, Lachseiern und frischer Chlorella.",
      category: "Unternehmens- & Branchen-Meilensteine",
    },
    ru: {
      title: "VARS на BISFE 2024: наше участие в рыбной выставке в Пусане",
      excerpt:
        "Проверенный обзор участия VARS в BISFE 2024 с цистами артемии, икрой лососевых и свежей хлореллой.",
      category: "Вехи компании и отрасли",
    },
    ja: {
      title: "VARSのBISFE 2024出展：釜山国際水産EXPOへの参加記録",
      excerpt:
        "アルテミア耐久卵、サケ卵、フレッシュクロレラを紹介したVARSのBISFE 2024公式出展記録。",
      category: "会社および業界の節目",
    },
    ko: {
      title: "VARS의 BISFE 2024 참가: 부산국제수산EXPO 전시 기록",
      excerpt:
        "아르테미아 내구란, 연어란, 신선 클로렐라를 소개한 VARS의 BISFE 2024 공식 참가 기록입니다.",
      category: "회사 및 업계 이정표",
    },
    zh: {
      title: "VARS亮相BISFE 2024：釜山国际海鲜与水产博览会参展回顾",
      excerpt: "经官方核实的VARS参展记录，展示丰年虫卵、鲑鱼卵和鲜活小球藻。",
      category: "公司与行业里程碑",
    },
    ar: {
      title: "مشاركة VARS في BISFE 2024: معرض بوسان الدولي للمأكولات البحرية ومصايد الأسماك",
      excerpt:
        "استعراض موثق لمشاركة VARS في BISFE 2024 وعرض أكياس الأرتيميا وبيض السلمون والكلوريلا الطازجة.",
      category: "إنجازات الشركة والصناعة",
    },
  },
  "olive-flounder-farming-1": {
    fa: {
      title: "پرورش کفشک زیتونی: فناوری RAS، پروتکل‌های لاروی و لجستیک صادرات",
      excerpt:
        "راهنمای جامع آبزی‌پروری Paralichthys olivaceus: پارامترهای مزارع خشکی RAS، از شیر گرفتن با آب سبز و حمل زنده در زنجیره سرما.",
      category: "پروژه‌ها و آزمون‌های میدانی",
    },
    tr: {
      title: "Olive Flounder Yetiştiriciliği: RAS ve Lojistik",
      excerpt:
        "Paralichthys olivaceus yetiştiriciliği kapsamlı rehberi: Kara tabanlı RAS parametreleri, yeşil su sütten kesme ve canlı soğuk zincir ihracatı.",
      category: "Saha Projeleri ve Denemeler",
    },
    es: {
      title:
        "Cultivo de Halibut del Japón: Tecnología RAS, Protocolos Larvarios y Logística Global",
      excerpt:
        "Guía técnica de acuicultura de Paralichthys olivaceus: parámetros en sistemas RAS terrestres, destete en agua verde y transporte vivo en cadena de frío.",
      category: "Proyectos de Campo y Ensayos",
    },
    fr: {
      title: "Élevage du cardeau hirame : RAS et logistique mondiale",
      excerpt:
        "Guide complet de l'aquaculture de Paralichthys olivaceus : paramètres des systèmes RAS à terre, sevrage en eau verte et transport sous chaîne du froid de poisson vivant de qualité sashimi.",
      category: "Projets",
    },
    de: {
      title:
        "Zucht der Japanischen Flunder (Hirame): RAS-Technologie, Larvenprotokolle und Globale Logistik",
      excerpt:
        "Technischer Leitfaden zur Paralichthys olivaceus Aquakultur: Landbasierte RAS-Parameter, Grünwasser-Entwöhnung und Lebendtransport in der Kühlkette.",
      category: "Feldprojekte & Versuche",
    },
    ru: {
      title:
        "Выращивание азиатского паралихта (хирамэ): технологии УЗВ, личиночные протоколы и логистика",
      excerpt:
        "Полное руководство по аквакультуре Paralichthys olivaceus: параметры наземных УЗВ, переход на искусственные корма и транспортировка живой рыбы.",
      category: "Полевые проекты и испытания",
    },
    ja: {
      title: "ヒラメ養殖技術：陸上RAS循環ろ過、仔稚魚プロトコルおよび生体空輸ロジスティクス",
      excerpt:
        "ヒラメ（Paralichthys olivaceus）養殖の包括的ガイド：陸上RAS水質管理、グリーンウォーター初期餌料系列、刺身品質の活魚低温輸送。",
      category: "実証プロジェクトと臨床試験",
    },
    ko: {
      title: "넙치(광어) 양식 기술: 육상 RAS 시스템, 자치어 사육 및 활어 수출 물류",
      excerpt:
        "넙치(Paralichthys olivaceus) 양식 종합 기술 가이드: 제주 육상 유수식 및 RAS 환경 지표, 그린워터 초기 먹이계열 및 활어 수송 프로토콜.",
      category: "현장 프로젝트 및 연구",
    },
    zh: {
      title: "牙鲆工厂化养殖技术：现代RAS循环水、仔稚鱼繁育与生食级活鱼空运物流",
      excerpt:
        "牙鲆（Paralichthys olivaceus）全周期养殖技术指南：陆基水质调控阈值、轮虫卤虫活体饵料序列及跨国低温休眠空运技术。",
      category: "田野项目与试验",
    },
    ar: {
      title: "استزراع سمك المفلطح الزيتوني: تقنيات RAS، بروتوكولات اليرقات وسلسلة التبريد للتصدير",
      excerpt:
        "دليل شامل لاستزراع Paralichthys olivaceus: معايير أنظمة التدوير المغلقة RAS، فطام اليرقات في المياه الخضراء، واللوجستيات الحية لأسواق الساشيمي.",
      category: "مشاريع ميدانية وتجارب",
    },
  },
  "aegean-region-kılıcdeniz-hatchery-trials-2": {
    fa: {
      title: "منطقه اژه — آزمون‌های مرکز تکثیر KılıçDeniz",
      excerpt: "مشتری: KılıçDeniz، بزرگ‌ترین شرکت آبزی‌پروری ترکیه",
      category: "پروژه‌ها و آزمون‌های میدانی",
    },
    tr: {
      title: "Ege Bölgesi – Kılıç Deniz Kuluçkahane Denemeleri",
      excerpt: "Kılıç Deniz Firması ile Gerçekleştirdiğimiz Canlı Yem Denemeleri",
      category: "Saha Projeleri ve Denemeler",
    },
    es: {
      title: "Región del Egeo: ensayos en el criadero de Kılıç Deniz",
      excerpt: "Nuestros ensayos de alimento vivo con Kılıç Deniz en Turquía",
      category: "Proyectos de Campo y Ensayos",
    },
    fr: {
      title: "Essais à l'écloserie KılıçDeniz : protocoles de proies vivantes",
      excerpt:
        "Essai technique de terrain chez KılıçDeniz : surmonter la vulnérabilité aux effondrements de cultures de rotifères, protocoles de dosage de la Super Fresh Chlorella V12 et multiplication par 8 de la densité.",
      category: "Projets",
    },
    de: {
      title: "Ägäis-Region – Versuche in der Kılıç Deniz Brutanstalt",
      excerpt: "Unsere Lebendfutterversuche mit Kılıç Deniz in der Türkei",
      category: "Feldprojekte & Versuche",
    },
    ru: {
      title: "Эгейский регион — испытания в инкубаторе Kılıç Deniz",
      excerpt: "Наши испытания живых кормов с Kılıç Deniz в Турции",
      category: "Полевые проекты и испытания",
    },
    ja: {
      title: "エーゲ海地域 – Kılıç Deniz 孵化場共同実証試験",
      excerpt: "トルコの Kılıç Deniz と取り組んだ生き餌共同実証試験",
      category: "実証プロジェクトと臨床試験",
    },
    ko: {
      title: "에게해 지역 – Kılıç Deniz 양식장 실증 시험",
      excerpt: "터키의 대형 수산업체 Kılıç Deniz와 함께한 생먹이 실증 시험",
      category: "현장 프로젝트 및 연구",
    },
    zh: {
      title: "爱琴海地区 – Kılıç Deniz 孵化场试验项目",
      excerpt: "我们与土耳其 Kılıç Deniz 开展的活体饲料对比试验",
      category: "田野项目与试验",
    },
    ar: {
      title: "منطقة بحر إيجة - تجارب مفرخ كليش دينيز",
      excerpt: "تجارب الأعلاف الحية بالتعاون مع شركة كليش دينيز في تركيا",
      category: "مشاريع ميدانية وتجارب",
    },
  },
  "decapsulated-artemia-cysts-aquarium-fish-nutrition-guide": {
    tr: {
      title: "Kabuksuz Artemia Yavru Balık Yemi: Seçim ve Hazırlama",
      excerpt:
        "Dekapsüle Artemia Yumurtası ile canlı nauplius arasında seçim: yem kabulü, hazırlama, hijyen ve tedarikçi şartnameleri.",
      category: "Kuluçkahane Yemi ve Tasarımı",
    },
    de: {
      title: "Dekapsulierte Artemia für Fischbrut: Auswahl und Zubereitung",
      excerpt:
        "Trockenes Artemia-Direktfutter oder lebende Nauplien: Futterannahme, Zubereitung, Hygiene und Lieferantenspezifikationen.",
      category: "Brutanlagenfutter & Design",
    },
    es: {
      title: "Artemia decapsulada para alevines: selección y preparación",
      excerpt:
        "Cómo elegir entre artemia decapsulada seca y nauplios vivos: aceptación, preparación, higiene y especificaciones del proveedor.",
      category: "Alimentación y Diseño de Criaderos",
    },
    fr: {
      title: "Artémia décapsulée pour alevins : choix et préparation",
      excerpt:
        "Choisir entre l'artémia décapsulée séchée et les nauplii vivants : acceptation de l'aliment, préparation, hygiène et spécifications fournisseur.",
      category: "Aliments et conception d'écloserie",
    },
    ru: {
      title: "Декапсулированная артемия для мальков: выбор и подготовка корма",
      excerpt:
        "Сухая декапсулированная артемия или живые науплии: поедаемость, подготовка, гигиена и спецификации поставщика.",
      category: "Корма и проектирование инкубаториев",
    },
    ar: {
      title: "الأرتيميا منزوعة القشرة لزريعة الأسماك: الاختيار والتحضير",
      excerpt:
        "المقارنة بين حويصلات الأرتيميا الجافة منزوعة القشرة ويرقات النوبليوس الحية من حيث تقبّل الغذاء والتحضير والنظافة ومواصفات المورد.",
      category: "أعلاف وتصميم المفرخات",
    },
    ja: {
      title: "稚魚用脱殻アルテミア飼料：選び方と調製方法",
      excerpt:
        "脱殻乾燥アルテミア耐久卵と生きたノープリウスを、摂餌性、調製、衛生、供給仕様から比較します。",
      category: "孵化場用飼料と設計",
    },
    ko: {
      title: "치어용 탈각 아르테미아 사료: 선택과 준비",
      excerpt:
        "탈각 건조 내구란과 살아 있는 노플리우스를 섭이 반응, 준비 방법, 위생 및 공급 규격으로 비교합니다.",
      category: "부화장 사료 및 설계",
    },
    zh: {
      title: "鱼苗用脱壳卤虫饲料：选择与制备",
      excerpt: "比较脱壳干燥卤虫卵与活体无节幼体，了解摄食接受度、制备、卫生和供应商规格。",
      category: "孵化场饲料与配方设计",
    },
    fa: {
      title: "آرتمیای دکپسوله برای بچه‌ماهی: انتخاب و آماده‌سازی خوراک",
      excerpt:
        "مقایسه سیست خشک دکپسوله با ناپلیوس زنده از نظر پذیرش خوراک، آماده‌سازی، بهداشت و مشخصات تأمین‌کننده.",
      category: "خوراک و طراحی هچری",
    },
  },
  "salmon-ova-hatching-accumulated-thermal-units-guide": {
    tr: {
      title: "Somon Yumurtası Kuluçkası: Gün-Derece ve Planlama",
      excerpt:
        "Yumurta inkübasyonu, su takibi, teslim alma ve ilk yemlemeyi sıcaklık kayıtları ve tedarikçi bilgileriyle planlama.",
      category: "Su Ürünleri Yetiştiriciliği",
    },
    de: {
      title: "Lachseier inkubieren: Tagesgrade und Brutplanung",
      excerpt:
        "Temperatursummen und Lieferantenangaben für Inkubation, Wasserüberwachung, Warenannahme und Erstfütterung nutzen.",
      category: "Aquakultur",
    },
    es: {
      title: "Incubación de ovas de salmón: grados-día y planificación",
      excerpt:
        "Planificar incubación, control del agua, recepción y primera alimentación con registros térmicos y orientación del proveedor.",
      category: "Acuicultura",
    },
    fr: {
      title: "Incubation des œufs de saumon : degrés-jours et planification",
      excerpt:
        "Utiliser les degrés-jours cumulés en complément des consignes du fournisseur pour planifier l'incubation, le suivi de l'eau, la réception et la première alimentation.",
      category: "Aquaculture",
    },
    ru: {
      title: "Инкубация икры лосося: градусо-дни и планирование",
      excerpt:
        "Планирование инкубации, контроля воды, приёмки и первого кормления по температурной истории и указаниям поставщика.",
      category: "Аквакультура",
    },
    ar: {
      title: "تحضين بيض السلمون: الدرجات الحرارية المتراكمة وتخطيط المفرخ",
      excerpt:
        "استخدام السجل الحراري وإرشادات المورد لتخطيط التحضين ومراقبة الماء والاستلام والتغذية الأولى.",
      category: "تربية الأحياء المائية",
    },
    ja: {
      title: "サケ受精卵の孵化管理：積算水温と生産計画",
      excerpt:
        "温度履歴と供給者の指示を組み合わせ、孵化、水質監視、受け入れ、初回給餌を計画します。",
      category: "水産養殖",
    },
    ko: {
      title: "연어 수정란 부화 관리: 적산수온과 종묘장 계획",
      excerpt: "수온 이력과 공급업체 지침을 활용해 부화, 수질 점검, 입고와 첫 급이를 계획합니다.",
      category: "수산양식",
    },
    zh: {
      title: "鲑鱼受精卵孵化：积温与育苗计划",
      excerpt: "结合累计温度和供应商指导，安排孵化、水质监测、收货及首次投喂。",
      category: "水产养殖",
    },
    fa: {
      title: "انکوباسیون تخم سالمون: درجه‌روز و برنامه‌ریزی مرکز تکثیر",
      excerpt:
        "برنامه‌ریزی انکوباسیون، پایش آب، تحویل و نخستین تغذیه با سابقه دمایی و راهنمایی تأمین‌کننده.",
      category: "آبزی‌پروری",
    },
  },
  "brown-meagre-aquaculture-grow-out-culinary-guide": {
    tr: {
      title: "Sarıağız: Tür Tanımlama, Üretim ve Şartnameler",
      excerpt:
        "Argyrosomus regius ile Sciaena umbra ayrımı; işleme, mutfak ve ihracat için yetiştiricilik ürünü sarıağızın tanımlanması.",
      category: "Saha Projeleri ve Denemeler",
    },
    de: {
      title: "Adlerfisch: Artbestimmung, Aufzucht und Einkaufsspezifikationen",
      excerpt:
        "Argyrosomus regius von Sciaena umbra unterscheiden und Zuchtadlerfisch für Verarbeitung, Küche und Export spezifizieren.",
      category: "Feldprojekte & Versuche",
    },
    es: {
      title: "Corvina: identificación, cultivo y especificaciones de compra",
      excerpt:
        "Diferenciar Argyrosomus regius de Sciaena umbra y especificar corvina de cultivo para procesado, cocina y exportación.",
      category: "Proyectos y Ensayos de Campo",
    },
    fr: {
      title: "Le maigre : identification, élevage et spécifications acheteur",
      excerpt:
        "Distinguer Argyrosomus regius de Sciaena umbra et spécifier le maigre d'élevage pour la transformation, la cuisine et l'export.",
      category: "Projets et essais de terrain",
    },
    ru: {
      title: "Серебристый горбыль (мэгр): вид, выращивание и спецификация закупки",
      excerpt:
        "Как отличить Argyrosomus regius от Sciaena umbra и задать требования к выращенному мэгру для переработки, кухни и экспорта.",
      category: "Полевые проекты и испытания",
    },
    ar: {
      title: "سمك اللوت (Argyrosomus regius): تحديد النوع والاستزراع ومواصفات الشراء",
      excerpt:
        "التمييز بين Argyrosomus regius وSciaena umbra وتحديد مواصفات اللوت المستزرع للتجهيز والمطابخ والتصدير.",
      category: "مشاريع وتجارب ميدانية",
    },
    ja: {
      title: "メイグル（Argyrosomus regius）：種の確認、養殖、購入仕様",
      excerpt:
        "Argyrosomus regiusとSciaena umbraを区別し、加工、調理、輸出向けの養殖メイグルを仕様化します。",
      category: "現場プロジェクトと実証実験",
    },
    ko: {
      title: "메아그레 (Argyrosomus regius): 종 확인, 양식과 구매 규격",
      excerpt:
        "Argyrosomus regius와 Sciaena umbra를 구분하고 가공, 조리 및 수출용 양식 메아그레의 규격을 정합니다.",
      category: "현장 프로젝트 및 실증 시험",
    },
    zh: {
      title: "大西洋白姑鱼：物种识别、养殖与采购规格",
      excerpt:
        "区分 Argyrosomus regius 与 Sciaena umbra，并为加工、餐饮和出口明确养殖大西洋白姑鱼的采购要求。",
      category: "田野项目与试验",
    },
    fa: {
      title: "میش‌ماهی (Argyrosomus regius): شناسایی گونه، پرورش و مشخصات خرید",
      excerpt:
        "تمایز Argyrosomus regius از Sciaena umbra و تعیین مشخصات ماهی پرورشی برای فرآوری، آشپزخانه و صادرات.",
      category: "پروژه‌ها و آزمون‌های میدانی",
    },
  },
  "vital-wheat-gluten-aquafeed-extrusion-binding-chemistry": {
    tr: {
      title: "Balık Yeminde Vital Buğday Gluteni ve Formülasyon",
      excerpt:
        "Glutenin işlevselliğini, ekstrüzyon koşullarını, pelet dayanımını ve besin dengesini evrensel performans iddialarına dayanmadan değerlendirme.",
      category: "Yem İnovasyonu ve Sürdürülebilirlik",
    },
    de: {
      title: "Vitalweizengluten im Aquafutter: Bindung und Rezepturversuche",
      excerpt:
        "Glutenfunktion, Extrusionsbedingungen, Pelletstabilität und Nährstoffbalance ohne pauschale Leistungsversprechen bewerten.",
      category: "Futtermittel-Innovation & Nachhaltigkeit",
    },
    es: {
      title: "Gluten vital de trigo en acuafeeds: unión y ensayos de formulación",
      excerpt:
        "Evaluar funcionalidad, extrusión, estabilidad del pellet y equilibrio nutricional sin promesas universales de rendimiento.",
      category: "Innovación en Piensos y Sostenibilidad",
    },
    fr: {
      title: "Gluten de blé vital : pouvoir liant et formulation",
      excerpt:
        "Évaluer la fonctionnalité du gluten, les conditions d'extrusion, la tenue des granulés et l'équilibre nutritionnel, sans promesse universelle de performance.",
      category: "Innovation alimentaire et durabilité",
    },
    ru: {
      title: "Глютен пшеничный кормовой: связывание гранул и испытания рецептуры",
      excerpt:
        "Оценка свойств глютена, экструзии, водостойкости гранул и питательного баланса без универсальных обещаний результата.",
      category: "Инновации в кормах и устойчивое развитие",
    },
    ar: {
      title: "جلوتين القمح الحيوي في الأعلاف المائية: الربط وتجارب التركيب",
      excerpt:
        "تقييم وظائف الجلوتين وظروف البثق وثبات الحبيبات والتوازن الغذائي دون ادعاءات أداء عامة.",
      category: "الابتكار والاستدامة في الأعلاف",
    },
    ja: {
      title: "養魚飼料の活性小麦グルテン：結着と配合試験",
      excerpt:
        "グルテンの機能、押出条件、ペレット安定性、栄養バランスを、一律の性能保証に頼らず評価します。",
      category: "飼料革新と持続可能性",
    },
    ko: {
      title: "양식 사료의 활성밀글루텐: 결착과 배합 시험",
      excerpt:
        "글루텐 기능, 압출 조건, 펠릿 안정성과 영양 균형을 일률적인 성능 주장 없이 평가합니다.",
      category: "사료 혁신 및 지속가능성",
    },
    zh: {
      title: "水产饲料中的谷朊粉：黏结作用与配方试验",
      excerpt: "评估谷朊粉功能、挤压条件、颗粒稳定性和营养平衡，避免套用通用性能承诺。",
      category: "饲料创新与可持续性",
    },
    fa: {
      title: "گلوتن گندم حیاتی در خوراک آبزیان: اتصال پلت و آزمون فرمول",
      excerpt:
        "ارزیابی عملکرد گلوتن، شرایط اکستروژن، پایداری پلت و توازن غذایی بدون ادعای نتیجه یکسان برای همه شرایط.",
      category: "نوآوری و پایداری در خوراک",
    },
  },
  "fish-meal-quality-grading-tvn-hatchery-nutrition": {
    tr: {
      title: "Balık Unu Kalitesi: İşleme, Analiz ve Alıcı Kontrolleri",
      excerpt:
        "Balık ununu parti kanıtları, analiz yöntemleri, işleme geçmişi ve hedef yeme uygunluğu üzerinden değerlendirme.",
      category: "Kuluçkahane Yemi ve Tasarımı",
    },
    de: {
      title: "Fischmehlqualität: Verarbeitung, Analysen und Einkaufskontrollen",
      excerpt:
        "Fischmehl anhand von Chargennachweisen, Analyseverfahren, Verarbeitungshistorie und Eignung für das geplante Futter bewerten.",
      category: "Brutanlagenfutter & Design",
    },
    es: {
      title: "Calidad de la harina de pescado: procesado, análisis y controles de compra",
      excerpt:
        "Evaluar harina de pescado con pruebas del lote, métodos analíticos, historial de procesado y adecuación al alimento previsto.",
      category: "Alimentación y Diseño de Criaderos",
    },
    fr: {
      title: "Qualité de la farine de poisson : procédé, analyse, contrôles",
      excerpt:
        "Évaluer une farine de poisson à partir des preuves du lot, des méthodes analytiques, de l'historique de transformation et de son adéquation à l'aliment visé.",
      category: "Aliments et conception d'écloserie",
    },
    ru: {
      title: "Качество рыбной муки: переработка, анализы и проверка закупки",
      excerpt:
        "Оценка рыбной муки по данным партии, аналитическим методам, истории производства и пригодности для заданного корма.",
      category: "Корма и проектирование инкубаториев",
    },
    ar: {
      title: "جودة مسحوق السمك: المعالجة والتحليل وفحوص الشراء",
      excerpt: "تقييم مسحوق السمك بأدلة الدفعة وطرق التحليل وسجل المعالجة وملاءمته للعلف المستهدف.",
      category: "أعلاف وتصميم المفرخات",
    },
    ja: {
      title: "魚粉の品質：加工、分析、購入時の確認",
      excerpt: "ロットの根拠資料、分析方法、加工履歴、対象飼料への適性から魚粉を評価します。",
      category: "孵化場用飼料と設計",
    },
    ko: {
      title: "어분 품질: 가공, 분석과 구매 확인",
      excerpt: "로트 근거, 분석 방법, 가공 이력과 목표 사료 적합성을 바탕으로 어분을 평가합니다.",
      category: "부화장 사료 및 설계",
    },
    zh: {
      title: "鱼粉质量：加工、分析与采购核查",
      excerpt: "根据批次证据、分析方法、加工历史和目标饲料适用性评估鱼粉。",
      category: "孵化场饲料与配方设计",
    },
    fa: {
      title: "کیفیت پودر ماهی: فرآوری، تحلیل و کنترل خرید",
      excerpt:
        "ارزیابی پودر ماهی بر اساس مدارک بچ، روش‌های تحلیل، سابقه فرآوری و تناسب با خوراک هدف.",
      category: "خوراک و طراحی هچری",
    },
  },
};
